import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form42 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.SickLeaveApplication,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {},
      },
      {
        type: "salutation",
        value: ["Giám đốc Chi nhánh Đà Nẵng;", "Trưởng phòng Kế hoạch hành chính;", "Trưởng Phòng/Trung tâm……"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "eEmployeeId",
            value: record?.eEmployeeId,
          },
          {
            type: "eWorkPlaceTeamAndDept",
            value: {
              place: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
              department: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
            },
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Giám đốc đồng ý giải quyết cho tôi được nghỉ ốm ▢ nuôi con ốm ▢ với thời gian như sau: `,
          },
          { type: "eVacationPeriodNoCount", value: record?.eVacationPeriods[0] },
          { type: "eExpectedReturnDate", value: record?.eExpectedReturnDate },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Giám đốc, Trưởng phòng Kế hoạch hành chính, Trưởng phòng/trung tâm.",
          },
          { type: "", value: "Xin trân trọng cảm ơn./." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TP. KẾ HOẠCH HÀNH CHÍNH", record?.eSteps[2][0].name],
          },
          {
            type: "signature1",
            value: ["TRƯỞNG BỘ PHẬN", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- Lưu: KHHC."],
          },
          {
            type: "signature1",
            value: ["GIÁM ĐỐC", record?.eSteps[3][0].name],
          },
        ],
      },
    ],
  };
};
